import { Divider } from '@chakra-ui/react';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { utils as commonUtils } from '@finley-technologies/common';

import { CollapsableSideBar } from 'packages/sidebar/ui/CollapsableSideBar';
import { SideBarItem } from 'packages/sidebar/ui/SideBarItem';
import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';

// Exports
export const CapitalProviderSideBar = () => {
  const flags = useFeatureFlags();
  const { pathname: currentPath } = useLocation();

  return (
    <CollapsableSideBar>
      <SideBarItem
        currentPath={currentPath}
        label="Portfolio"
        routeName="portfolio"
        icon="house"
      />
      {!commonUtils.EnvUtils.isProduction() && (
        <SideBarItem
          currentPath={currentPath}
          label="Credit Agreements"
          routeName="credit-agreements"
          icon="file-lines"
        />
      )}
      <SideBarItem
        currentPath={currentPath}
        label="Funding Requests"
        routeName="funding-requests"
        icon="dollar-sign"
      />
      <SideBarItem
        routeName="deliverables"
        currentPath={currentPath}
        label="Deliverables"
        icon="calendar"
      />
      <SideBarItem
        routeName="reports"
        currentPath={currentPath}
        label="Reports"
        icon="folder-arrow-down"
      />

      <Divider style={{ marginTop: '24px', marginBottom: '24px' }} />

      <SideBarItem
        routeName="calculation-terminologies"
        currentPath={currentPath}
        label="Calculation Terminologies"
        icon="book"
      />
      {/* Too hard to filter events - just hide the entire section if we're filtering facilities. */}
      {!flags?.creditFacilitySlugsToHide?.length && (
        <SideBarItem
          routeName="events"
          currentPath={currentPath}
          label="Events Log"
          icon="clock"
        />
      )}
      <SideBarItem
        routeName="settings"
        currentPath={currentPath}
        label="Settings"
        icon="gear"
      />
      {flags?.showGraphMonitor && (
        <SideBarItem
          routeName="bbpl-monitor"
          currentPath={currentPath}
          label="Data Pipeline"
          icon="monitor-waveform"
        />
      )}
      {flags?.showDataPipeline && (
        <SideBarItem
          routeName="data-pipeline"
          currentPath={currentPath}
          label="Data Pipeline v2"
          icon="timeline-arrow"
        />
      )}
      {flags?.enableUndoPipelineRun && (
        <SideBarItem
          routeName="undo-pipeline-run"
          currentPath={currentPath}
          label="Undo Pipeline Run"
          icon="undo"
        />
      )}
    </CollapsableSideBar>
  );
};
